export default "__VITE_ASSET__FciIrxzZ__"